import accounting from 'accounting'


function PriceFormatter(price) {
	if (price === null) {
		return null;
	}

	//Fetch currency data from sessionStorage and use default values if they are not set
	var symbol = (sessionStorage.getItem("currencyShowSymbol") ? sessionStorage.getItem("currencySymbol") : '');
	var thousand = (sessionStorage.getItem("currencyThousandsSeparator") !== '' && sessionStorage.getItem("currencyThousandsSeparator") !== 'undefined' ? sessionStorage.getItem("currencyThousandsSeparator") : '');
	var decimal = (sessionStorage.getItem("currencyDecimalSeparator") !== '' && sessionStorage.getItem("currencyDecimalSeparator") !== 'undefined' ? sessionStorage.getItem("currencyDecimalSeparator") : '.');

	//Format the price with the help of the accounting lib
	var formattedPrice = accounting.formatMoney(price, {
		symbol: symbol,
		thousand: thousand,
		decimal:  decimal,
		precision: 2,
		format: "%s %v"
	});

	//Add zero decimals replacement if defined
	if (sessionStorage.getItem("currencyZeroDecimalsReplacement") !== 'undefined') {
		var decSep = sessionStorage.getItem("currencyDecimalSeparator") || '.';
		formattedPrice = formattedPrice.replace(/\,00/, ',' + sessionStorage.getItem("currencyZeroDecimalsReplacement"));
	}

	return formattedPrice;
}

export default PriceFormatter;
